import React from 'react';
import ScrollspyNav from "react-scrollspy-nav";
import { Container, Nav } from 'react-bootstrap';
import ScrollspyNavItemHome from "../layout/ScrollspyNavItemHome";
import SubNavigationTeaserButton from "../layout/SubNavigationTeaserButton";
import Homeslider from "../sections/Homeslider";
// import Teilnehmer from "../sections/Teilnehmer";
import MultiPressekonferenz from "../sections/MultiPressekonferenz";
import Kontaktmesse from "../sections/Kontaktmesse";
// import Teilnahme from "../sections/Teilnahme";
import Themen from "../sections/Themen";
// import ZuGast from "../sections/ZuGast";
// import Stimmen from "../sections/Stimmen";
import RbsPage from '../controls/RbsPage';
import Firmenteilnehmer from '../sections/Firmenteilnehmer';
import Redaktionen from '../sections/Redaktionen';
import Warum from "../sections/Warum";
import Vorteile from "../sections/Vorteile";
import Interview from "../sections/Interview";
// import Danke from '../sections/Danke';

const Startseite = () => {

  return (
    <RbsPage>

      <nav className="navbar sticky-md-top subnav">
        <Container>
          <ScrollspyNav scrollTargetIds={["Warum", "Teilnehmer", "Interview", "MultiPressekonferenz", "Kontaktmesse", "Themen"]} offset={0} activeNavClass="active" scrollDuration="10" headerBackground="true">
            {/* <ScrollspyNav scrollTargetIds={["Teilnehmer", "MultiPressekonferenz", "Kontaktmesse", "Teilnahme", "Themen", "ZuGast"]} offset={0} activeNavClass="active" scrollDuration="10" headerBackground="true"> */}
            <Nav variant="pills">
              <ScrollspyNavItemHome />
              <Nav.Item>
                <Nav.Link href="#Warum">Warum?</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#Teilnehmer">Wer nimmt teil?</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#Interview">Stimmen</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#MultiPressekonferenz">Multi-Pressekonferenz</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#Kontaktmesse">Pressegespräche</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#Themen">Themen</Nav.Link>
              </Nav.Item>
            </Nav>
          </ScrollspyNav>
        </Container>
        <SubNavigationTeaserButton />


      </nav>


      {/* 
      <Danke />
*/}

      <section id="Homeslider" className="custom-section-grey"><Homeslider /></section>
      <section id="Warum" className=""><Warum /></section>
      <section id="Vorteile" className="custom-section-grey pb-0"><Vorteile /></section>
      <section id="Teilnehmer" className="" style={{ minHeight: '0px' }}><Firmenteilnehmer /></section>
      <section id="Redaktionen"><Redaktionen /></section>
      <section id="Interview" className="custom-section-grey"><Interview /></section>

      <section id="MultiPressekonferenz"><MultiPressekonferenz /></section>
      <section id="Kontaktmesse"><Kontaktmesse /></section>
      <section id="Themen"><Themen /></section>


    </RbsPage>
  )

}

export default Startseite;
